import { observerEpicHelper } from 'epics/helpers'
import { Constants as AlgoliaData, Actions as AlgoliaDataActions } from 'actions/algolia2/data'
import { selectedFacetsToAlgoliaQueryString } from 'lib/algolia/v2'
import { algoliaCollectionsBrowseApi } from 'apis/algolia'
import {
  getAlgoliaDataHitsPerPage,
  getAlgoliaDataPaginationCurrent,
  getAlgoliaSearchIndice,
  getAlgoliaUserToken,
  getSelectedFacets,
} from 'selectors/algolia2/data'
import { getDataLayer } from '../selectors/dataLayer'
export const updateAlgoliaEpic = observerEpicHelper(
  [AlgoliaData.FETCH_DATA, AlgoliaData.LOAD_MORE_DATA],
  async ({ action, observer, store }) => {
    // Fetch Algolia Data
    const searchIndice = getAlgoliaSearchIndice({ ...store.value })
    const hitsPerPage = getAlgoliaDataHitsPerPage({ ...store.value })
    const pageNumber = getAlgoliaDataPaginationCurrent({ ...store.value })
    const selectedFacets = getSelectedFacets({ ...store.value })
    const userToken = getAlgoliaUserToken({ ...store.value })
    const filters = selectedFacetsToAlgoliaQueryString(
      {
        is_visible: 'true',
        is_private: 'false',
        ...selectedFacets,
      } // selected facets
    )
    const algoliaParams = {
      searchIndice,
      filters,
      hitsPerPage,
      page: action.type === AlgoliaData.LOAD_MORE_DATA ? pageNumber + 2 : 0,
      userToken,
      // Accept override params => `page`
      ...(action.payload ? action.payload : {}),
    }
    const algoliaData = await algoliaCollectionsBrowseApi(algoliaParams)

    if (action.payload && Object.keys(action.payload)) {
      observer.next(AlgoliaDataActions.SET_DATA(algoliaData))
    } else {
      // Load more data
      observer.next(AlgoliaDataActions.MERGE_HITS_RESULTS(algoliaData))
    }

    // Get/Update DataLayer
    const dataLayer = getDataLayer({ ...store.value })
    window.dataLayer.push({ ...dataLayer, event: 'pageview' })
    observer.complete()
  }
)
export default [updateAlgoliaEpic]